export default "__VITE_ASSET__h1gRmPm2__"